import styled from "styled-components";

export const Container = styled.main`
  .inner{
    padding-top: 100px;
    padding-bottom: 100px;
    input{
      height: 45px;
      margin: 0 auto;
      border-radius: 6px;
      + input{
        margin-top: 12px;
      }
    }

    > button{
      height: 48px;
      margin: 0 auto;
      border: none;
      border-radius: 6px;

      &:not(.sns){
        margin-top: 24px;
        strong{
          letter-spacing: 2px;
        }
      }
    }

    .group_link{  
      margin-top: 20px;
      a{
        padding: 10px 6px;
        border: none;
        background-color: transparent;
        &:hover{
          text-decoration: underline;
        }
        + a{
          margin-left: 12px;
          position: relative;
          &::before{
            content: '';
            width: 2px;
            height: 2px;
            border-radius: 50%;
            background-color: #222;
            position: absolute;
            top: 50%;
            left: -6px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }


    hr{
      width: 360px;
      margin: 30px auto 40px;
    }
    button.sns{
      padding: 0;
      background-color: transparent;
      overflow: hidden;

      + button{
        margin-top: 20px;
      }

      &.kakao{
        background-color: #FEE500;
      }
      &.naver{
        background-color: #03c75a;
      }
      &.google{
        background-color: #4285F4;
      }

      img{
        height: 100%;
        /* margin: auto; */
      }
    }
  }


  @media screen and (min-width: 501px) {
    .inner{
      input, > button{
        width: 360px;
      }
    }
  }

  @media (max-width: 500px) {
    .inner{
      input, > button{
        width: 100%;
      }
    }
  }
`